import React from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import IngresoActions from "../../../stores/ingreso/Actions";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../components/Common/TittleLine";
import { IngresoFormButtonsContainer } from "../styles/IngresoStyles";
import { EMPRESA } from "../../../utils/Constant";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import Colors from "../../../themes/Colors";
import AfiliadoIngresoDetalle from "../components/AfiliadoIngresoDetalle";
import AutorizacionIngresoDetalle from "../components/AutorizacionIngresoDetalle";
import ProcedimientosIngresoDetalle from "../components/ProcedimientosIngresoDetalle";
import { CONFIG_VOUCHER } from "../../autorizacion/utils/AutorizacionConstant";
import CustomModal from "../../../components/CustomModal/CustomModal";
import MedicosParticipantesTabla from "../components/MedicosParticipantesTabla";

const DetalleCierreCuentaScreen = (props) => {
  const {
    formCierreCuentasData,
    consultarDetalleCierreCuentaLoading,
    authUserData,
  } = props;

  const location = useLocation();

  const numeroIngreso = location?.state?.numeroIngreso;

  const anioIngreso = location?.state?.anioIngreso;

  const { prestador } = authUserData;

  const history = useHistory();

  const empresa = useEmpresa();

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useMountEffect(() => {
    if (!isPrimera || !authUserData?.prestador?.permiteCierreCuenta) {
      history.push("/dashboard");
      return;
    }

    props.consultarDetalleCierreCuenta({
      numeroIngreso: numeroIngreso,
      anioIngreso: anioIngreso,
      compania: empresa?.CODIGO,
      reclamante: authUserData?.prestador,
      formCierreCuentasData,
      formHandler: props.formCierreCuentas,
    });
  });

  const showModalLoader = () => {
    return consultarDetalleCierreCuentaLoading;
  };

  const onOpenModalMedicosParticipantes = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalMedicosParticipantes: true,
    });
  };

  const onCloseModalMedicosParticipantes = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalMedicosParticipantes: false,
    });
  };

  const imprimirVoucher = (isMatricial) => {
    const newTab = window.open(
      `/voucher-cierre-cuenta?isMatricial=${isMatricial}&numeroIngreso=${numeroIngreso}&anioIngreso=${anioIngreso}&sinHonorarios=${!prestador?.esPaquete}`,
      "_blank",
      isMatricial ? CONFIG_VOUCHER.MATRICIAL : CONFIG_VOUCHER.TERMICO
    );

    newTab.focus();
  };

  const imprimirVoucherHonorarios = (isMatricial) => {
    const newTab = window.open(
      `/voucher-cierre-cuenta?isMatricial=${isMatricial}&numeroIngreso=${numeroIngreso}&anioIngreso=${anioIngreso}&soloHonorarios=true`,
      "_blank",
      isMatricial ? CONFIG_VOUCHER.MATRICIAL : CONFIG_VOUCHER.TERMICO
    );

    newTab.focus();
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={"relative"}
      footerWidth={"auto"}
    >
      <Section>
        <TittleLine
          title={`Detalle cierre de cuenta clínica: ${formCierreCuentasData?.numeroReclamacion}`}
          weight={"bold"}
        />
      </Section>

      <Section>
        <AfiliadoIngresoDetalle />
      </Section>

      <Section padding={"5px"}>
        <AutorizacionIngresoDetalle />
      </Section>

      <Section align="center" flexDirection={"column"} padding={"10px"}>
        <ProcedimientosIngresoDetalle />
      </Section>

      <Section>
        <TittleLine />
      </Section>

      <Section align={"center"} padding={"10px"}>
        <IngresoFormButtonsContainer>
          <CustomButton
            label={"Voucher Matricial"}
            onClick={() => imprimirVoucher(true)}
            isLoading={false}
            weight={"bold"}
            hoverColor={empresa?.COLOR_PRINCIPAL}
            bgColor={Colors.white}
            textColor={empresa?.COLOR_PRINCIPAL}
            border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"Voucher Térmico"}
            onClick={() => imprimirVoucher(false)}
            isLoading={false}
            weight={"bold"}
            hoverColor={empresa?.COLOR_PRINCIPAL}
            bgColor={Colors.white}
            textColor={empresa?.COLOR_PRINCIPAL}
            border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
          />
          <CheckRender allowed={false}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Voucher Matricial Honorarios"}
              onClick={() => imprimirVoucherHonorarios(true)}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Voucher Térmico Honorarios"}
              onClick={() => imprimirVoucherHonorarios(false)}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
          </CheckRender>
          <CheckRender allowed={formCierreCuentasData?.tieneMedicos}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Voucher Médico"}
              onClick={onOpenModalMedicosParticipantes}
              isLoading={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
          </CheckRender>
        </IngresoFormButtonsContainer>
      </Section>

      <CustomModal
        isOpen={formCierreCuentasData?.showModalMedicosParticipantes}
        onClose={onCloseModalMedicosParticipantes}
      >
        <MedicosParticipantesTabla />
      </CustomModal>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={formCierreCuentasData?.showAlert}>
        <CustomAlert {...formCierreCuentasData?.alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,

  consultarDetalleCierreCuentaLoading:
    state.ingreso.consultarDetalleCierreCuentaLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  consultarDetalleCierreCuenta: IngresoActions.consultarDetalleCierreCuenta,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DetalleCierreCuentaScreen);
